//#region types
import { AuthEnums } from "models/enums";
import { StoppedPaymentsListExtended } from "models/propTypes/stoppedPaymentPropTypes";
import useAPIClientHelper from "./useAPIClientHelper";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
//#endregion

function useStoppedPaymentsService() {
  const { apiClientInstance } = useAPIClientHelper();

  const getStoppedPaymentsListExtended = (stoppedPayments: WintSuperkollAPIModel.StoppedPayment[]) => {
    return stoppedPayments.map((stoppedPayment) => stoppedPayment as StoppedPaymentsListExtended);
  };

  const getTotalSelectedPaymentsAmount = (selectedPayments: WintSuperkollAPIModel.StoppedPayment[]) => {
    let totalAmount = 0;
    selectedPayments.forEach((payment) => {
      totalAmount = totalAmount + (payment.amount ?? 0);
    });
    return totalAmount;
  };
  const getStoppedPayments = () => {
    return apiClientInstance(AuthEnums.AuthType.Company, {
      showErrors: true,
    })
      .StoppedPaymentClient.GetStoppedPaymentsInfo()
      .then((res) => res.data);
  };

  const approveStoppedPayments = (payments: WintSuperkollAPIModel.RescheduleStoppedPayments) => {
    return apiClientInstance(AuthEnums.AuthType.Company, {
      showErrors: true,
    })
      .StoppedPaymentClient.RescheduleStoppedPayments(payments)
      .then((res) => res.data);
  };

  return {
    getStoppedPaymentsListExtended,
    getTotalSelectedPaymentsAmount,
    getStoppedPayments,
    approveStoppedPayments,
  };
}

export default useStoppedPaymentsService;
